import { render, staticRenderFns } from "./chara-drawer.vue?vue&type=template&id=be70184c&"
import script from "./chara-drawer.vue?vue&type=script&lang=js&"
export * from "./chara-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports